import { render, staticRenderFns } from "./PartDetailsLink.vue?vue&type=template&id=46da27df"
import script from "./PartDetailsLink.vue?vue&type=script&lang=js"
export * from "./PartDetailsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports